import { Redirect, Route } from "react-router-dom";

const ProtectedRoute = (props) => {
    const ls = require("localstorage-ttl");

    const { level } = props;
    const usuario = JSON.parse(ls.get("userData"));
    const token = JSON.parse(ls.get("jwt"));

    const hasLevel = !level || 
                      level === null || 
                      (usuario && level <= usuario.level);

    return token && hasLevel ? (
      <Route {...props} />
    ) : (
      <Redirect to={{ pathname: "/" }}/>
    );
};

export default ProtectedRoute;